import { login, getMe } from '@/api/user';
import { User, Role, UserState } from '@/types/user';
import { RootState } from '@/types/store';
import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';
import _ from 'lodash';

type UserGetter = GetterTree<UserState, RootState>;

const state: UserState = {
  user: {
    administrator: false,
  },
  authenticated: undefined,
};

const getters: UserGetter = {
  user: state => state.user,
  administrator: state => state.user.administrator,
  authenticated: state => state.authenticated,
};

const actions: ActionTree<UserState, RootState> = {
  async login({ dispatch }, credentials): Promise<void> {
    const tokens = await login(credentials);
    if (tokens) {
      await dispatch('getMe');
    }
  },

  async logout({ commit }): Promise<void> {
    localStorage.removeItem('access_token');
    await commit('unSetUser');
  },

  async getMe({ commit }): Promise<void> {
    const user = await getMe();
    if (
      _.find(
        user.roles,
        role =>
          role.name === 'Content Manager' ||
          role.name === 'Content Administrator',
      )
    ) {
      user.administrator = _.some(user.roles, {
        name: 'Content Administrator',
      });
      await commit('setUser', user);
    } else {
      await commit('unSetUser');
    }
  },
};

const mutations: MutationTree<UserState> = {
  setUser(userState, user: User) {
    userState.authenticated = true;
    userState.user = user;
  },

  unSetUser(userState) {
    userState.authenticated = false;
    userState.user = {
      administrator: false,
    };
  },
};

const user: Module<UserState, RootState> = {
  state,
  getters,
  actions,
  mutations,
  namespaced: true,
};

export default user;
